import { DateTime } from 'luxon';
import * as enums from './Enums';
import { IOrganizationListingModel } from './OrganizationListingModel';
import { IUserModel } from './UserModel';
export interface IOrganizationRelationListingModel {
  organizationRelationId: number;
  authApplicationId: number;
  organizationId: number;
  key: string;
  isDefault: boolean;
  startDate: string;
  endDate: string | undefined;
  organizationName: string;
  organizationDescription: string;
  organizationType: string;
  organizationTypeId: number;
  organizationVersion: string;
  organizationVersionId: number;
  organizationSourceName: string;
  organizationSourceId: number;
}

export class OrganizationRelationListingModel
  implements IOrganizationRelationListingModel
{
  organizationRelationId: number;
  authApplicationId: number;
  organizationId: number;
  key: string;
  isDefault: boolean;
  startDate: string;
  endDate: string | undefined;
  organizationName: string;
  organizationDescription: string;
  organizationType: string;
  organizationTypeId: number;
  organizationVersion: string;
  organizationVersionId: number;
  organizationSourceName: string;
  organizationSourceId: number;

  constructor(params: Partial<IOrganizationRelationListingModel>) {
    const {
      organizationRelationId = 0,
      authApplicationId = 0,
      organizationId = 0,
      key = '',
      isDefault = false,
      startDate = DateTime.utc().toISODate(),
      endDate = undefined,
      organizationName = '',
      organizationDescription = '',
      organizationType = '',
      organizationTypeId = 0,
      organizationVersion = '',
      organizationVersionId = 0,
      organizationSourceName = '',
      organizationSourceId = 0,
    } = params;

    this.organizationRelationId = organizationRelationId;
    this.authApplicationId = authApplicationId;
    this.organizationId = organizationId;
    this.key = key;
    this.isDefault = isDefault;
    this.startDate = startDate;
    this.endDate = endDate;
    this.organizationName = organizationName;
    this.organizationDescription = organizationDescription;
    this.organizationType = organizationType;
    this.organizationTypeId = organizationTypeId;
    this.organizationVersion = organizationVersion;
    this.organizationVersionId = organizationVersionId;
    this.organizationSourceName = organizationSourceName;
    this.organizationSourceId = organizationSourceId;
  }

  static GetUserOrganizationFromListingOrganization(
    user: IUserModel,
    organization: IOrganizationListingModel,
  ) {
    return new OrganizationRelationListingModel({
      organizationRelationId: 0,
      authApplicationId: 1,
      organizationId: organization.organizationId,
      key: 'user-' + user.userId,
      startDate: DateTime.now().toISO(),
      endDate: undefined,
      organizationName: organization.name,
      organizationType: organization.organizationType,
      organizationTypeId: organization.organizationTypeId,
      organizationVersion: organization.organizationVersion,
      organizationVersionId: organization.organizationVersionId,
      organizationSourceName: organization.organizationSource,
      organizationDescription: organization.description,
      organizationSourceId: organization.organizationSourceId,
    });
  }

  static CreateForUserOrgRelation(
    user: IUserModel,
    organization: IOrganizationListingModel,
  ): IOrganizationRelationListingModel {
    return new OrganizationRelationListingModel({
      organizationRelationId: 0,
      authApplicationId: enums.AuthApplicationIds.Clinic,
      organizationId: organization.organizationId,
      key: user.organizationRelationKey,
    });
  }
}
